import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCommentDots } from '@fortawesome/free-regular-svg-icons';
import { GeneAiUiModule } from '@gene-ai/ui/gene-ai-ui.module';

@Component({
  selector: 'app-assistant-avatar',
  imports: [
    GeneAiUiModule,
    FontAwesomeModule
  ],
  templateUrl: './assistant-avatar.component.html',
  styleUrl: './assistant-avatar.component.css',
  standalone: true,
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})
export class AssistantAvatarComponent {
  @Input() icon: 'assistant' | 'dialog' = 'dialog';
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  protected readonly faCommentDotsIcon = faCommentDots;
}
